export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=559f92c9&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/players/index.vue?vue&type=template&id=559f92c9&scoped=true
// module id = 6nZJ
// module chunks = 0